const Mario = {
  level1: '#FFCBD2',
  Ma100: '#FFCBD2',
  level2: '#F69799',
  Ma200: '#F69799',
  level3: '#EE6D71',
  Ma300: '#EE6D71',
  level4: '#FF3030',
  Ma400: '#FF3030',
  level5: '#DE132A',
  Ma500: '#DE132A',
  level6: '#D10322',
  Ma600: '#D10322',
};

export { Mario };
